/**
 * @generated SignedSource<<5247d7df701e654a8a477d8fb833796c>>
 * @relayHash f1349222e8edf4730ccbe4f8945c258d
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 964db7270fc909d08496e957a2dac28a6cb9a76e6037014be90d660206dd5040

import type { PreloadableConcreteRequest } from 'relay-runtime';
import type { uiGrowthRecommendPremiumToStandardModal_GetStartStandardTrialUrlQuery } from './uiGrowthRecommendPremiumToStandardModal_GetStartStandardTrialUrlQuery.graphql';

const node: PreloadableConcreteRequest<uiGrowthRecommendPremiumToStandardModal_GetStartStandardTrialUrlQuery> = {
  "kind": "PreloadableConcreteRequest",
  "params": {
    "id": "964db7270fc909d08496e957a2dac28a6cb9a76e6037014be90d660206dd5040",
    "metadata": {},
    "name": "uiGrowthRecommendPremiumToStandardModal_GetStartStandardTrialUrlQuery",
    "operationKind": "query",
    "text": null
  }
};

export default node;
